import { SubmitSurveyResponsePayload, SurveyQuestionQm } from '~lib/generatedGqlTypes';

const filterVisibleQuestions = (
  questionsToFilter: SurveyQuestionQm[],
  visibleQuestionIds: SubmitSurveyResponsePayload['visibleQuestionIds']
): SurveyQuestionQm[] => {
  if (!visibleQuestionIds) {
    return questionsToFilter;
  }

  return questionsToFilter.filter(question => visibleQuestionIds.includes(question.id));
};

export default filterVisibleQuestions;
